import { ColorMode } from '@lux/core';
/**
 * @deprecated This will just return color value itself according to the theme
 */
export const getThemeColor = (theme) => (light, dark) => (theme === null || theme === void 0 ? void 0 : theme.colorMode) === ColorMode.DARK ? dark !== null && dark !== void 0 ? dark : light : light;
//# sourceMappingURL=helper.js.map